"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
exports.primaryKeyMissingRule = void 0;
exports.isPrimaryKeysMissing = isPrimaryKeysMissing;
const utils_1 = require("@azimutt/utils");
const database_1 = require("../../database");
const databaseUtils_1 = require("../../databaseUtils");
const rule_1 = require("../rule");
/**
 * Primary Keys are the default unique way to get a single row in a table.
 * They are also often used on foreign keys to reference a single record.
 * Having a primary key on every table is a common best practice.
 */
const ruleId = 'primary-key-missing';
const ruleName = 'missing primary key';
const ruleDescription = 'entities with no primary key (only tables)';
const CustomRuleConf = rule_1.RuleConf.extend({
    ignores: database_1.EntityId.array().optional(),
}).strict().describe('PrimaryKeyMissingConf');
exports.primaryKeyMissingRule = {
    id: ruleId,
    name: ruleName,
    description: ruleDescription,
    conf: { level: rule_1.RuleLevel.enum.high },
    zConf: CustomRuleConf,
    analyze(conf, now, db, queries, history, reference) {
        const refIgnores = reference.map(r => r.entity).filter(utils_1.isNotUndefined);
        const ignores = refIgnores.concat(conf.ignores?.map(databaseUtils_1.entityRefFromId) || []);
        return (db.entities || [])
            .filter(isPrimaryKeysMissing)
            .filter(e => !ignores.some(i => (0, databaseUtils_1.entityRefSame)(i, (0, databaseUtils_1.entityToRef)(e))))
            .map(e => ({
            ruleId,
            ruleName,
            ruleLevel: conf.level,
            message: `Entity ${(0, databaseUtils_1.entityToId)(e)} has no primary key.`,
            entity: (0, databaseUtils_1.entityToRef)(e)
        }));
    }
};
// same as frontend/src/PagesComponents/Organization_/Project_/Views/Modals/SchemaAnalysis/PrimaryKeyMissing.elm
function isPrimaryKeysMissing(entity) {
    return (entity.kind === undefined || entity.kind === database_1.EntityKind.enum.table) && entity.pk === undefined;
}
//# sourceMappingURL=primaryKeyMissing.js.map